import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import { EnvironmentService } from '@ecm/consumer';

@Injectable({
    providedIn: 'root',
})
export class ToggleService {
    public constructor(protected environmentService: EnvironmentService) {}

    /**
     * Get toggle feature status
     *  Path in env.json : ex. FEATURES_TOGGLE.FEATURE_TEAM_NAME.XXX.YYY.ZZZ
     * @param featurePath {string} ex. XXX.YYY.ZZZ
     * @param defaultValue {boolean} Default value to use in error case
     * @returns {Observable<boolean>}
     */
    public getFeatureStatus(featurePath: string, defaultValue = false): Observable<boolean> {
        return of(this.environmentService.instant(`FEATURES_TOGGLE.${featurePath}`, defaultValue));
    }
}
